import { createSelector } from '@reduxjs/toolkit';

import { ObjectChecked } from '@paragon/contract-library';
import { getGroupingMapWithMultiKeySelector } from '@paragon/utilities';

import { RootState } from '..';
import { getActiveComponentDesign } from './getActiveComponentDesignSelector';
import { getAnalogModelForActiveComponentDesign } from './getAnalogModelForActiveComponentDesignSelector';
import { getCheckResultsForActiveLoadCaseByObjectGuid } from './getCheckResultsByObjectGuidSelectors';
import { getCheckResultsForMember } from './getCheckResultsForActiveLoadCaseAndItemSelector';

export const getCheckedMembersByCheckResultForActiveLoadCase = createSelector(
  (state: RootState) => getActiveComponentDesign(state)?.component.members,
  getCheckResultsForActiveLoadCaseByObjectGuid,
  getAnalogModelForActiveComponentDesign,
  (members, checkResultsByObjectGuid, analogModel): ReadonlyMap<string, readonly ObjectChecked[]> | null => {
    if (!members || !checkResultsByObjectGuid) {
      return null;
    }
    return getGroupingMapWithMultiKeySelector(
      members.map((member) => ({ guid: member.guid, type: member.memberType, name: member.name })),
      (checkedMember) =>
        getCheckResultsForMember(checkResultsByObjectGuid, checkedMember.guid, analogModel).map(
          (checkResult) => checkResult.guid,
        ),
    );
  },
);
